import { render, staticRenderFns } from "./PacienteForm.vue?vue&type=template&id=47d99145&"
import script from "./PacienteForm.vue?vue&type=script&lang=js&"
export * from "./PacienteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports